export const daysOfWeek = [
  "Monday",
  "Tuesday",
  "Wednesday",
  "Thursday",
  "Friday",
  "Saturday",
  "Sunday",
];

export const mealTimes = ["Breakfast", "Lunch", "Dinner", "Snack1", "Snack2"];
